export default __webpack_public_path__ + "static/media/send.d06982da.svg";